import styled from 'styled-components'

import { fromMd, untilMd } from '@syconium/little-miss-figgy'

export const Container = styled.div`
  left: 0;
  position: absolute;
  top: 0;
  user-select: none;

  ${untilMd} {
    padding: 4px 18px;
    background: white;
    border-radius: 50px;
    margin: 16px;
  }

  ${fromMd} {
    margin: 48px 52px;
  }
`
